import { useQuery } from '@tanstack/react-query';
import { timelineService } from '../services/timelineService';

export function useTimeline(siteId: number | undefined) {
  return useQuery({
    queryKey: ['timeline', siteId],
    queryFn: () => timelineService.getTimeline(siteId!),
    enabled: !!siteId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
